import { db } from '../../common/config/Firebase';

/**
 * Deletes an employee from Firestore
 * @param {string} dni - Employee DNI (document ID)
 * @returns {Promise<void>}
 */
export const deleteEmployeeUseCase = async (dni) => {
    try {
        await db.collection('employees').doc(dni).delete();
        console.log(`Employee deleted: ${dni}`);
    } catch (error) {
        console.error('Error deleting employee:', error);
        throw error;
    }
};
